import React from 'react';
import ButtonsWidget from '@plone/volto/components/manage/Widgets/ButtonsWidget';
import imageLeftSVG from '@plone/volto/icons/image-left.svg';
import imageRightSVG from '@plone/volto/icons/image-right.svg';
import imageFitSVG from '@plone/volto/icons/image-fit.svg';
import imageNarrowSVG from '@plone/volto/icons/image-narrow.svg';
import imageWideSVG from '@plone/volto/icons/image-wide.svg';
import imageFullSVG from '@plone/volto/icons/image-full.svg';

export const defaultActionsInfo = () => ({
  left: [imageLeftSVG, 'left'],
  right: [imageRightSVG, 'right'],
  center: [imageFitSVG, 'center'],
  // INTERAKTIV CODE
  normal: [imageFitSVG, 'normal'],
  // END
  narrow: [imageNarrowSVG, 'narrow'],
  wide: [imageWideSVG, 'width'],
  full: [imageFullSVG, 'full'],
});

const AlignWidget = (props) => {
  const { actions = ['left', 'right', 'center', 'full'], actionsInfoMap } =
    props;

  const actionsInfo = {
    ...defaultActionsInfo(),
    ...actionsInfoMap,
  };

  return (
    <ButtonsWidget
      {...props}
      actions={actions}
      actionsInfoMap={actionsInfo}
      // INTERAKTIV CODE
      defaultAction={props.defaultAction || 'center' || 'normal'}
      // END
    />
  );
};

export default AlignWidget;
